import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'

export const ServiceProductsCard = styled(Card, {
  name: 'ServiceProductsCard',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  border: 'solid 1px #ddd',
  borderRadius: 4,
  marginBottom: theme.spacing(2.4),
  width: '573px',
}))
